import React from "react";
import s from "./RoundMini.less";
import clsx from "clsx";

interface IRoundMiniProps {
  size?: {
    width: number;
    height: number;
  };
  status: "good" | "bad" | "appealStarted";
}

export const RoundMini = ({
  status,
  size = { width: 12, height: 12 },
}: IRoundMiniProps) => (
  <div style={size} className={clsx(s.status, { [s[status]]: true })} />
);
